import { render, staticRenderFns } from "./sharedNode.vue?vue&type=template&id=ae21992a&scoped=true"
import script from "./sharedNode.vue?vue&type=script&lang=js"
export * from "./sharedNode.vue?vue&type=script&lang=js"
import style0 from "./sharedNode.vue?vue&type=style&index=0&id=ae21992a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae21992a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae21992a')) {
      api.createRecord('ae21992a', component.options)
    } else {
      api.reload('ae21992a', component.options)
    }
    module.hot.accept("./sharedNode.vue?vue&type=template&id=ae21992a&scoped=true", function () {
      api.rerender('ae21992a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/claimRecordManage/components/sharedNode.vue"
export default component.exports